import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgIconComponent } from '@ng-icons/core';
import type { Question } from '../../interfaces/questionInterface';

@Component({
    selector: 'app-repeat-list',
    imports: [NgIconComponent],
    templateUrl: './list.component.html',
    styleUrl: './list.component.scss'
})
export class RepeatListComponent {
  _model: Question[] = [];

  @Input('questions')
  set model(questions: Question[]) {
    this._model = questions;
    this.setupFilters();
    this.filteredQuestions = questions;
  }
  get model(): Question[] {
    return this._model;
  }

  @Output() toggleModal = new EventEmitter<void>();
  @Output() questionSelected = new EventEmitter<string>();

  public filters = [] as string[];
  public activeFilter:string|null = null;
  public filteredQuestions = [] as Question[];

  setupFilters() {
    const exams = this.model.flatMap(q => q.exams);
    const examNames: string[] = exams.filter(exam => !!exam).map(exam => exam?.name ?? '');
    this.filters = [...new Set<string>(examNames)];
  }

  public handleQuestionSelected(questionId: string) {
    this.toggleModal.emit();
    this.questionSelected.emit(questionId);
  }

  getExamNames(question: Question): string[] {
    return question.exams?.map(exam => exam.name) ?? [];
  }

  applyFilter(filter: string) {
    this.activeFilter = filter;
    this.filteredQuestions = this.model.filter(q => q.exams?.some(exam => exam.name === filter));
  }

  public clearFilter() {
    this.activeFilter = null;
    this.filteredQuestions = this.model;
  }
}
